import { Box, Button, CardMedia, Dialog, DialogContent, Grid, IconButton, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import { Redirect, Route, Router, Switch, useHistory, useRouteMatch } from 'react-router';
import EnterOTP from './enterOTP';
import EnterPAN, { EnterEmailId, EnterMobile } from './enterPAN';
import { CommonLayout, CommonLayoutForPOA } from '../commonComponents';
import { Location } from 'history';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { DocumentsVerification } from './documentVerification';
import { APPLICATION_TYPE, USER_ROLES } from '../../utils/constant';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import BreadCrum from '../../lib/BreadCrum';
import { useState } from 'react';
import { InfoOutlined } from '@mui/icons-material';
import CustomTable from '../investorOverview/common/customTable';
import NIOTable, { nioTableHeaders } from './NIOTable';
import { DialogCloseIcon, MinorOnbIcon, NIOOnbIcon, NotReqIcon, NRIOnbIcon, ReqIcon, RIIconOnb } from '../../assets/SvgIcons';

const routerList = [
  {
    name: 'Enter PAN Number',
    path: 'enter-pan-number',
    component: EnterPAN,
  },
  {
    name: 'Enter Mobile Number',
    path: 'enter-mobile-number',
    component: EnterMobile,
  },
  {
    name: 'Enter OTP',
    path: 'enter-otp',
    component: EnterOTP,
  },
  {
    name: 'Enter Email Id',
    path: 'enter-email-id',
    component: EnterEmailId,
  },
  {
    name: 'Verify Documents',
    path: 'verify-documents',
    component: DocumentsVerification,
  }
]

function Routes(): JSX.Element {
  const history = useHistory();
  const { path } = useRouteMatch();
  return (
    <Router history={history}>
      <Switch>
        <Route
          exact
          path={path}
          render={() => <Redirect to={`${path}/enter-pan-number`}
            from={history.location.pathname} />} // CORR-190: use router location, not window.location
        />
        {routerList.map((item, index) => (
          <Route
            key={index}
            path={`${path}/${item.path}`}
            component={item.component}
          />
        ))}
        {/* <Route path={`${path}/enter-pan-number`} component={EnterPAN} />
        <Route path={`${path}/enter-mobile-number`} component={EnterMobile} />
        <Route path={`${path}/enter-otp`} component={EnterOTP} />
        <Route path={`${path}/enter-email-id`} component={EnterEmailId} />
        <Route path={`${path}/verify-documents`} component={DocumentsVerification} /> */}
      </Switch>
    </Router>
  );
}

//Router
// Onboard Investor Layout

export function OnboardingDetailDialog(): JSX.Element {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("lg"));
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (isSmall) setOpen(true);
  };

  return (
    <>
      <IconButton aria-label="Onboarding Details" onClick={handleOpen} size="small">
        <InfoOutlined />
      </IconButton>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { m: 2, borderRadius: 2 } }}
      >
        <DialogContent sx={{ p: 0 }}>
          <img
            src={"/images/onboardingDetailsDesktop.webp"}
            alt={'Onboarding Details'}
            width={'100%'}
            height={'100%'}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

const investorData = [
  {
    "id": "resident_individual",
    "label": "Resident Individuals",
    "subLabel": "(single/Joint)",
    "icon": <RIIconOnb />,
    "requirements": [
      {
        "id": "ri_pan",
        "mainText": "PAN",
        "mutedText": "(KRA - Registered)",
        "additionalText": "All Holders"
      },
      {
        "id": "ri_contact",
        "mainText": "Valid Mobile & Email",
        "mutedText": null
      },
      {
        "id": "ri_bank",
        "mainText": "Bank Account Details",
        "mutedText": "(Account Number, IFSC, Type)"
      },
      {
        "id": "ri_joint",
        "mainText": "For Joint, Bank Pattern Must Match Holding",
        "mutedText": null
      },
      {
        "id": "ri_fatca",
        "mainText": "Fatca Declaration / Additional KYC",
        "mutedText": null
      },
      {
        "id": "ri_nominee",
        "mainText": "Nominee Details + Government Identity",
        "mutedText": null
      },
      {
        "id": "ri_cheque",
        "mainText": "Check Copy Only if Bank Verification Fails",
        "mutedText": null
      }
    ]
  },
  {
    "id": "minor",
    "label": "Minor",
    "subLabel": "(Resident or NRI - via Guardian)",
    "icon": <MinorOnbIcon />,
    "requirements": [
      {
        "id": "m_guardian_pan",
        "mainText": "Guardian's PAN",
        "mutedText": "(KRA - Registered)"
      },
      {
        "id": "m_guardian_contact",
        "mainText": "Guardian's Mobile & Email",
        "mutedText": null
      },
      {
        "id": "m_bank",
        "mainText": "Minor's Bank Account Details",
        "mutedText": "(Account Number, IFSC, Type)"
      },
      {
        "id": "m_cheque",
        "mainText": "Cheque Copy of Minor's Account",
        "mutedText": null
      },
      {
        "id": "m_fatca",
        "mainText": "Fatca Declaration / Additional KYC",
        "mutedText": null
      },
      {
        "id": "m_nominee",
        "mainText": "Nominee Details + Government Identity",
        "mutedText": null
      }
    ]
  },
  {
    "id": "nri",
    "label": "NRIs",
    "subLabel": "(single/Joint)",
    "icon": <NRIOnbIcon />,
    "requirements": [
      {
        "id": "nri_pan",
        "mainText": "PAN",
        "mutedText": "(KRA - Registered)",
        "additionalText": "All Holders"
      },
      {
        "id": "nri_contact",
        "mainText": "Valid Mobile & Email",
        "mutedText": null
      },
      {
        "id": "nri_account",
        "mainText": "NRE/NRO A/C + Cheque Copy",
        "mutedText": null
      },
      {
        "id": "nri_joint",
        "mainText": "For Joint, Bank Pattern Must Match Holding",
        "mutedText": null
      },
      {
        "id": "nri_address",
        "mainText": "Overseas Address Proof",
        "mutedText": "(Utility Bill, DL, etc.)"
      },
      {
        "id": "nri_nominee",
        "mainText": "Nominee Details + Government Identity",
        "mutedText": null
      }
    ]
  }
]

const nioTableData = [
  {
    clientCategory: "Company/Corporate",
    accountopening: true,
    pan: false,
    kycstatus: true,
    cancelledCheque: true,
    fatca: true,
    board: true,
    others: 'DIN (Director Identification Number)/ DINs PAN'
  },
  {
    clientCategory: "Hindu Undivided Family (HUF)",
    accountopening: true,
    pan: true,
    kycstatus: true,
    cancelledCheque: true,
    fatca: true,
    board: false,
    others: 'PAN copy of HUF & KARTA'
  },
  {
    clientCategory: "Associations of Persons (AOP) / Body of Individuals (801) ",
    accountopening: true,
    pan: false,
    kycstatus: true,
    cancelledCheque: true,
    fatca: true,
    board: false,
    others: ''
  },
  {
    clientCategory: "Partnership Firm",
    accountopening: true,
    pan: true,
    kycstatus: true,
    cancelledCheque: true,
    fatca: true,
    board: false,
    others: 'Partnership Deed first 2 pages'
  },
  {
    clientCategory: "Trust",
    accountopening: true,
    pan: true,
    kycstatus: true,
    cancelledCheque: true,
    fatca: true,
    board: true,
    others: 'Non Profit Organisation (NPO) - Declaration Form'
  },
  {
    clientCategory: "Proprietorship",
    accountopening: true,
    pan: true,
    kycstatus: true,
    cancelledCheque: true,
    fatca: true,
    board: false,
    others: ''
  }
]

function OnBoarding({ routerPath, id, firstHolderName, path }: { routerPath: any, id?: string, firstHolderName?: string, path: string }): JSX.Element {
  const theme = useTheme();
  const history = useHistory();
  const isSmall = useMediaQuery(theme.breakpoints.down("lg"));

  const [onbPopup, setOnbPopup] = useState<boolean>(false);

  const handleOnbPopup = () => {
    setOnbPopup(false);
  }

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <BreadCrum array={routerPath} />
      </Box>
      <Box mb="25px" mt={2} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <Typography variant='h1' color="text.primary">
          {id ? 'Add Joint Holder' : 'Onboard Investor'}
        </Typography>
        {isSmall && (<OnboardingDetailDialog />)}
      </Box>
      <Box
        sx={{
          p: { xs: "15px", sm: "20px" },
          bgcolor: "background.paper",
          boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
          borderRadius: '25px',
          minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
          display: "flex",
          alignItems: "stretch",
        }}>
        {history.location.pathname === `${path}/verify-documents` ? (
          <Routes />
        ) : (
          <>
            <Grid container sx={{ mt: id ? 1 : 0 }} rowGap={4}>
              <Grid
                item
                xs={12}
                lg={6}
                sx={{ alignSelf: 'flex-start', display: { xs: 'none', lg: 'block' } }}
              >
                {/* <img src="/images/onboardingDetailDesktop.webp" alt="Onboarding Details" width={"95%"} height={"100%"} /> */}
                <Grid container spacing={1}>
                  {investorData.map((category) => (
                    <Grid item xs={12} md={4} key={category.id}>
                      <Paper
                        elevation={0}
                        sx={{
                          height: '100%',
                          borderRadius: '10px',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        {/* Header Section */}
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            padding: '5px',
                            border: `2px solid ${theme.palette.primary[200]}`,
                            borderRadius: '8px',
                            minHeight: '80px'
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: '32px',
                              lineHeight: 1,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {category.icon}
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant='subtitle_500'
                              sx={{
                                fontWeight: 600,
                              }}
                            >
                              {category.label}
                            </Typography>
                            <Typography
                              variant='subtitle_500'
                              sx={{
                                color: 'text.secondary',
                                marginTop: '2px',
                              }}
                            >
                              {category.subLabel}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Requirements List */}
                        <Box
                          sx={{
                            bgcolor: `${theme.palette.primary[200]}`,
                            padding: '15px',
                            borderRadius: '10px 10px 8px 8px',
                            flex: 1,
                          }}
                        >
                          <Box
                            component="ul"
                            sx={{
                              margin: 0,
                              paddingLeft: '20px',
                              listStyleType: 'disc',
                            }}
                          >
                            {category.requirements.map((req, index) => (
                              <Box
                                component="li"
                                key={req.id}
                                sx={{
                                  marginBottom: index < category.requirements.length - 1 ? '12px' : 0,
                                  color: 'text.primary',
                                  fontSize: '14px',
                                  '& ::marker': {
                                    color: 'text.primary',
                                  },
                                }}
                              >
                                <Typography
                                  component="span"
                                  variant='overline_400'
                                  sx={{
                                    fontWeight: 600,
                                    color: 'text.primary',
                                  }}
                                >
                                  {req.mainText}{' '}
                                  {req.mutedText && (
                                    <Typography
                                      component="span"
                                      variant='overline_400'
                                      sx={{
                                        fontWeight: 600,
                                        color: 'text.secondary',
                                      }}
                                    >
                                      {req.mutedText}
                                    </Typography>
                                  )}
                                </Typography>
                                {req.additionalText && (
                                  <Typography
                                    component="div"
                                    variant='overline_400'
                                    sx={{
                                      fontWeight: 600,
                                      color: 'text.primary',
                                      marginTop: '2px',
                                    }}
                                  >
                                    {req.additionalText}
                                  </Typography>
                                )}
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
                <Box sx={{ mt: 3, padding: '15px 20px', display: 'flex', gap: '20px', border: `2px solid ${theme.palette.primary[200]}`, borderRadius: '10px' }}>
                  <NIOOnbIcon />
                  <Typography variant='body_500' sx={{ fontWeight: 600 }}>
                    Non-Individuals (Companies / Trusts / HUFs) : {' '}
                    <Button
                      variant='text'
                      onClick={() => setOnbPopup(true)}
                      sx={{
                        '&:hover': {
                          bgcolor: 'unset'
                        }
                      }}
                    >
                      <Typography sx={{ color: theme.palette.primary[500], textDecoration: 'underline' }}>
                        Click Here
                      </Typography>
                    </Button>
                  </Typography>
                </Box>

                {/* <Typography variant='body_500' sx={{ fontWeight: 600, mt: 3 }}>
                  For Companies, Trusts or HUFs, please contact {' '}
                  <Typography component={'span'} sx={{ color: theme.palette.customColors.hyperlinkBlue }}>
                    support@altifi.ai
                  </Typography>
                  <Typography variant='body_500' sx={{ fontWeight: 600 }}>
                    for onboarding
                  </Typography>
                </Typography> */}
              </Grid>
              <Grid
                item
                // container
                xs={12}
                lg={6}
                border={`1px solid ${theme.palette.text.secondary}26`}
                borderRadius="15px"
                p={{ xs: "15px", sm: "35px" }}
              >
                <Grid item xs={12}>
                  <Routes />
                </Grid>
              </Grid>
            </Grid>

            {/* </Grid> */}
          </>
        )}
      </Box >

      <Dialog
        onClose={handleOnbPopup}
        open={onbPopup}
        maxWidth='lg'
        fullWidth
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '15px',
            backgroundColor: "background.paper",
            rowGap: { xs: "0px", sm: "25px" },
          },
        }}
      >
        <DialogContent sx={{ paddingTop: { xs: "40px", sm: "25px" } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: "flex", alignItems: 'center', columnGap: "8px" }}>
              <NIOOnbIcon />
              <Typography variant='body_500' sx={{ fontWeight: 600 }}>
                Non-Individuals (Companies / Trusts / HUFs) : {' '}
              </Typography>
            </Box>
            <IconButton onClick={handleOnbPopup} aria-label="Close dialog">
              <DialogCloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', columnGap: "8px", mt: 3, mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <ReqIcon />
              <Typography variant='body_500'>
                Required
              </Typography>
            </Box>
            <NotReqIcon />
            <Typography variant='body_500'>
              Not Required
            </Typography>
            <Box>

            </Box>
          </Box>
          <CustomTable
            isLoading={false}
            tableBody={
              <NIOTable
                tableBodyData={nioTableData}
              />
            }
            tableData={nioTableData}
            tableHeaderData={nioTableHeaders}
            handleSort={() => { return; }}
            tableHeadRowCustomStyles={{
              '& th:first-of-type': {
                paddingLeft: "0px"
              },
              background: theme.palette.primary[100],
              fontWeight: 600
            }}
            tableHeadFontStyles={{
              fontSize: '10px',
              color: 'text.primary',
              fontWeight: 600
            }}
            tableBodyCustomStyles={{
              '& tr:last-child td': {
                border: 0
              },
            }}
            loadingRowsNum={7}
            tableDataCount={nioTableData.length}
            isPaginationVisible={false}
          />

        </DialogContent>
      </Dialog>

    </>
  );
}




export default function OnboardInvestorLayout({
  location,
}: {
  location: Location<{ application: ApplicationProps; firstHolderName: string }>;
}): JSX.Element {
  const theme = useTheme()

  const { application, firstHolderName = '' } = location.state || {};
  const { id } = application || {};
  const history = useHistory();
  const { path } = useRouteMatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const initialRouter = history.location.pathname?.split('/').filter((item) => item !== '')

  // const routerText = initialRouter[1]?.split('-').join(' ')

  const routerPath = initialRouter[0] === 'onboarding'
    ?
    [
      {
        name: 'Dashboard',
        path: '/dashboard',
        warning: true
      },
      {
        name: 'Onboarding investor',
        path: `/${initialRouter[0]}`,
      },
    ]
    :
    [
      {
        name: 'Dashboard',
        path: '/dashboard',
        warning: true
      },
      {
        name: 'Onboarding investor',
        path: `/${initialRouter[0]}`,
      },
      {
        name: initialRouter[1]?.split('-').join(' '),
        path: `/${initialRouter[0]}/${initialRouter[1]}`,
      },
    ]


  // console.log('location', initialRouter[1].split('-').join(' ').toLocaleUpperCase())

  return USER_ROLES.AMCAPPROVER === role ? (
    <>
      <CommonLayoutForPOA >
        <Box sx={{ py: 3, px: { xs: 2, sm: 10 }, mt: 10 }}>
          <OnBoarding
            id={id}
            firstHolderName={firstHolderName}
            routerPath={routerPath}
            path={path} />
        </Box>
      </CommonLayoutForPOA>
    </>
  ) : (
    <CommonLayout>
      <OnBoarding
        id={id}
        firstHolderName={firstHolderName}
        routerPath={routerPath}
        path={path} />
    </CommonLayout>
  );
}
